import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { blogPosts } from '../../../mocks/blogPosts';
import { getLangPath, getBlogDetailPath, type Language } from '../../../router/langRoutes';

const BlogPreviewSection = () => {
  const { t, i18n } = useTranslation('latvia');
  const currentLang = i18n.language as Language;

  return (
    <section className="py-8 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-6 md:mb-12">
          <div>
            <h2 className="text-base md:text-3xl font-bold text-gray-900 font-serif mb-1 md:mb-2">
              {t('detail.blog.title')} <strong>{t('detail.blog.titleBold')}</strong>
            </h2>
            <p className="text-[10px] md:text-base text-gray-500">
              {t('detail.blog.description')}
            </p>
          </div>
          <Link
            to={getLangPath('latviaBlog', currentLang)}
            className="hidden md:inline-flex items-center px-5 py-2.5 bg-white text-gray-700 text-sm font-medium rounded-lg border border-gray-300 hover:border-gold-400 hover:text-gold-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('detail.blog.viewAll')}
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8">
          {blogPosts.slice(0, 3).map((post) => (
            <Link
              key={post.id}
              to={getBlogDetailPath(post.id, currentLang)}
              className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100 cursor-pointer block"
            >
              <div className="relative w-full h-36 md:h-52 overflow-hidden">
                <img
                  src={post.image}
                  alt={`${post.title} - Định cư Latvia`}
                  title={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-black/60 backdrop-blur-sm text-white text-[10px] md:text-xs font-medium rounded-md">
                  {post.category}
                </span>
              </div>
              <div className="p-3 md:p-5">
                <h3 className="text-xs md:text-base font-bold text-gray-900 mb-1 md:mb-2 line-clamp-2 group-hover:text-gold-700 transition-colors leading-snug">
                  {post.title}
                </h3>
                <p className="text-[10px] md:text-sm text-gray-500 line-clamp-2 mb-2 md:mb-3 leading-relaxed">
                  {post.excerpt}
                </p>
                <div className="flex items-center gap-2 text-[9px] md:text-xs text-gray-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {post.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {post.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-5 md:hidden">
          <Link
            to={getLangPath('latviaBlog', currentLang)}
            className="inline-flex items-center px-4 py-2 bg-white text-gray-700 text-xs font-medium rounded-lg border border-gray-300 hover:border-gold-400 hover:text-gold-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('detail.blog.viewAllMobile')}
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogPreviewSection;